import { Divider as DividerMain } from './Divider';
export function createDivider({ Root, }) {
    const Divider = DividerMain(Root);
    Divider.displayName = 'Divider';
    return Divider;
}
